import { ActionList, ActionMenu, Box } from "@primer/react";
import React, { useMemo } from "react";

export type StudentFilterType = "dang_hoc" | "all";

export interface ISelectBoxTrangThaiDangHocProps {
    value: StudentFilterType;
    onValueChanged: (val: StudentFilterType) => void;
    size?: "small" | "medium" | "large";
}

const filterOptions: { id: StudentFilterType; text: string }[] = [
    { id: "dang_hoc", text: "Hiển thị học sinh đang học" },
    { id: "all", text: "Hiển thị toàn bộ học sinh" },
];

export const SelectBoxTrangThaiDangHoc: React.FC<ISelectBoxTrangThaiDangHocProps> = ({
    value,
    onValueChanged,
    size = "small",
}) => {
    const selectedItem = useMemo(() => {
        return filterOptions.find((o) => o.id === value) || filterOptions[0];
    }, [value]);

    return (
        <ActionMenu>
            <ActionMenu.Button
                size={size}
                style={{
                    height: size === "small" ? 28 : 32,
                    fontSize: size === "small" ? "12px" : "13px",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {selectedItem.text}
            </ActionMenu.Button>
            <ActionMenu.Overlay width="auto">
                <ActionList selectionVariant="single">
                    <Box sx={{ px: 3, py: 1.5, fontSize: 12, fontWeight: 600, color: "fg.muted" }}>
                        Lọc trạng thái học sinh
                    </Box>
                    {filterOptions.map((item) => (
                        <ActionList.Item
                            key={item.id}
                            selected={value === item.id}
                            onSelect={() => {
                                onValueChanged(item.id);
                            }}
                        >
                            {item.text}
                        </ActionList.Item>
                    ))}
                </ActionList>
            </ActionMenu.Overlay>
        </ActionMenu>
    );
};

export default SelectBoxTrangThaiDangHoc;
